import React from 'react';
import s from './NamesListV3Desktop.scss';

import NamesContainer from './NamesContainer/NamesContainer';
import NamesPageHeader from './Header/NamesPageHeader';

class NamesListV3Desktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const {
      onIndustryChange,
      onBusinessIdeaChange,
      t,
      businessIdea,
      industry,
      currentIndexIsOpen,
      onNameLineClicked,
      namesList,
      onSearchNames,
      screenType,
      loading,
      industriesFetcher,
      onLikeClicked,
      onDomainClicked,
      referralInfo
    } = this.props;

    return (
      <div key="page" className={s.page}>
        <NamesPageHeader
          screenType={screenType}
          businessIdea={businessIdea}
          industry={industry}
          onBusinessIdeaChange={onBusinessIdeaChange}
          onIndustryChange={onIndustryChange}
          t={t}
          onSearchNames={onSearchNames}
          industriesFetcher={industriesFetcher}
          key="HeaderContainer"
        />
        <div key="names" className={s.pageContentContainer}>
          <NamesContainer
            t={t}
            namesList={namesList}
            industry={industry}
            currentIndexIsOpen={currentIndexIsOpen}
            onNameLineClicked={onNameLineClicked}
            onLikeClicked={onLikeClicked}
            onDomainClicked={onDomainClicked}
            referralInfo={referralInfo}
            key="NamesContainer"
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

export default NamesListV3Desktop;
